import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';

import { PNET_APP_QUERY_PARAM } from '../../../common/partsNetConstants';
import { getFileURL } from '../../../../redux/actions';
import { routes } from '../../../../redux/api/routes';

const { resources } = routes;

const PartsNetPriceSheets = () => {
	const [pricingFiles, setPricingFiles] = useState();
	const { user } = useSelector(({ user }) => ({ user }));
	const dispatch = useDispatch();

	useEffect(() => {
		const fetchPricingFiles = () => {
			const subAccountClassification = user.selectedPriceSource['Sub Account Classification'] || '';
			const queryString = `requestType=getPriceReports&subClass=${subAccountClassification.split('-').at(-1)}&${PNET_APP_QUERY_PARAM}`;

			dispatch(
				getFileURL(resources.partsPricingFile.path, queryString, partsPricingFilesResponse => {
					if (partsPricingFilesResponse && partsPricingFilesResponse.responseObject && Array.isArray(partsPricingFilesResponse.responseObject)) {
						const pricingFiles =
							partsPricingFilesResponse.responseObject && partsPricingFilesResponse.responseObject.length
								? partsPricingFilesResponse.responseObject
										.map(pricingFile => {
											if (pricingFile.docFolder && pricingFile.docFolder.toLowerCase().includes('monthly-pricing')) {
												return {
													...pricingFile,
													linkTitle: `Price File${
														pricingFile.lastModifiedDate
															? ' - Last Modified: ' + moment(pricingFile.lastModifiedDate, 'YYYYMMDD').format('MMM DD, YYYY')
															: ''
													}`
												};
											}
											if (pricingFile.docFolder && pricingFile.docFolder.toLowerCase().includes('future-pricing')) {
												return {
													...pricingFile,
													linkTitle: `Future Price File${
														pricingFile.effectiveDate ? ' - Effective ' + moment(pricingFile.effectiveDate, 'YYYYMMDD').format('MMM DD, YYYY') : ''
													}`
												};
											}
										})
										.filter(pricingFile => pricingFile.linkTitle)
								: [];

						setPricingFiles(pricingFiles);
					} else {
						setPricingFiles([]);
					}
				})
			);
		};

		fetchPricingFiles();
	}, []);

	const handlePricingFile = (itemIndex, e) => {
		e.preventDefault();
		const pricingFile = pricingFiles[itemIndex];
		const queryString = `requestType=getPriceReports&docName=${pricingFile.docName}&docFolder=${pricingFile.docFolder}&${PNET_APP_QUERY_PARAM}`;

		dispatch(
			getFileURL(resources.partsPricingFile.path, queryString, partsPricingFileResponse => {
				if (partsPricingFileResponse.status) {
					partsPricingFileResponse.responseObject &&
						partsPricingFileResponse.responseObject[0] &&
						partsPricingFileResponse.responseObject[0].docLink &&
						window.open(partsPricingFileResponse.responseObject[0].docLink);
				}
			})
		);
	};

	return (
		<div>
			<h1 className="pageTitle" style={{ margin: '21px 0' }}>
				Price Sheets
			</h1>
			<div className="searchResults">
				{pricingFiles &&
					(pricingFiles.length > 0 ? (
						<ul style={{ listStyle: 'none', margin: 0 }}>
							{pricingFiles.map((item, index) => {
								return (
									<li key={index} style={{ marginBlock: '1rem' }}>
										<a href="" onClick={handlePricingFile.bind(this, index)}>
											{item.linkTitle}
										</a>
									</li>
								);
							})}
						</ul>
					) : (
						<p className="bold">No Price Sheets found for the selected account.</p>
					))}
			</div>
		</div>
	);
};

export default PartsNetPriceSheets;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/PriceSheets/partsNetPriceSheets.jsx